module.exports = __webpack_public_path__ + "img/bts-btpt-membership.d0a961ee.png";